module.exports = __webpack_public_path__ + "img/bgwelcome03.fd4d3ef9.jpg";